var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.token)?_c('div',{staticClass:"all text-center"},[_c('h1',{staticClass:"text-primary"},[_vm._v("SMS - Builderall")]),_c('br'),_c('button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.redirectToOffice()}}},[_vm._v("Enter")]),_c('br'),_vm._v(" "+_vm._s(this.token)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }